import React, { useState } from 'react';

import { hasSupabaseEnv, supabase } from './supabaseClient';
import copy from './i18n/sv.json';
import './App.css';

function getThemeToggleLabel(theme) {
  return theme === 'dark' ? copy.app.themeToggleLight : copy.app.themeToggleDark;
}

export default function LoginPanel({ theme, onToggleTheme }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  if (!hasSupabaseEnv || !supabase) {
    return (
      <div className="auth-page">
        <div className="theme-toggle-wrap">
          <button type="button" className="button button--secondary theme-toggle" onClick={onToggleTheme}>
            {getThemeToggleLabel(theme)}
          </button>
        </div>
        <div className="auth-card">
          <div className="auth-header">
            <p className="auth-kicker">{copy.login.adminLabel}</p>
            <h1 className="auth-title">{copy.login.missingSupabaseTitle}</h1>
            <p className="auth-description">
              Fyll i <code>REACT_APP_SUPABASE_URL</code> och <code>REACT_APP_SUPABASE_ANON_KEY</code>{' '}
              i frontendens <code>.env</code> innan du loggar in.
            </p>
          </div>
        </div>
      </div>
    );
  }

  async function handleLogin(event) {
    event.preventDefault();
    setSubmitting(true);
    setMessage('');
    setError('');

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    if (signInError) {
      setError(signInError.message || 'Kunde inte logga in.');
    }

    setSubmitting(false);
  }

  async function handleResetPassword() {
    if (!email.trim()) {
      setError(copy.login.missingEmailForReset);
      setMessage('');
      return;
    }

    setResetting(true);
    setError('');
    setMessage('');

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin
    });

    if (resetError) {
      setError(resetError.message || copy.login.resetFailed);
      setResetting(false);
      return;
    }

    setMessage(copy.login.resetSent);
    setResetting(false);
  }

  return (
    <div className="auth-page">
      <div className="theme-toggle-wrap">
        <button type="button" className="button button--secondary theme-toggle" onClick={onToggleTheme}>
          {getThemeToggleLabel(theme)}
        </button>
      </div>
      <div className="auth-card">
        <div className="auth-header">
          <p className="auth-kicker">{copy.login.adminLabel}</p>
          <h1 className="auth-title">{copy.login.loginTitle}</h1>
          <p className="auth-description">{copy.login.loginDescription}</p>
        </div>

        <form className="auth-form" onSubmit={handleLogin}>
          <label className="field">
            <span className="field-label">{copy.login.emailLabel}</span>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>

          <label className="field">
            <span className="field-label">{copy.login.passwordLabel}</span>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          {error ? <p className="auth-feedback auth-feedback--error">{error}</p> : null}
          {message ? <p className="auth-feedback auth-feedback--success">{message}</p> : null}

          <div className="auth-actions">
            <button type="submit" className="button button--primary" disabled={submitting}>
              {submitting ? copy.login.loggingInButton : copy.login.loginButton}
            </button>

            <button
              type="button"
              className="button button--secondary"
              disabled={resetting}
              onClick={handleResetPassword}
            >
              {resetting ? copy.login.sendingReset : copy.login.forgotPassword}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
